import { render, staticRenderFns } from "./reset_password_done.vue?vue&type=template&id=accc43ce&scoped=true"
import script from "./reset_password_done.vue?vue&type=script&lang=js"
export * from "./reset_password_done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accc43ce",
  null
  
)

export default component.exports